<template>
    <div :class="`stockTotalChange ${cssCls}`">{{ totalChange }}</div>
</template>

<script>
import StockHtmlHelper from '../stocks/StockHtmlHelper';

export default {
    props: {
        value: { type: Number, required: true },
        dark: { type: Boolean, default: false }
    },
    data() {
        return {
            stockHtmlHelper: null
        }
    },
    created() {
        this.stockHtmlHelper = new StockHtmlHelper();
    },
    computed: {
        cssCls() {
            const classes = []
            classes.push(this.value > 0 ? 'up' : this.value < 0 ? 'down' : '')
            classes.push(this.dark ? 'dark' : '')
            return classes.filter(c => c).join(' ')
        },
        totalChange() {
            const symbol = this.value > 0 ? '+' : ''
            return `${symbol}${this.stockHtmlHelper.formatPrice(this.value)}`
        }
    }
}
</script>

<style lang="scss" scoped>
.stockTotalChange {
    font-weight: bold;
    &.up{
        color: var(--v-greenUp-base);
    }
    &.down{
        color: var(--v-redDown-base);
    }
    &.dark {
        &.up {
            color: var(--v-lightGreenUp-base);
        }
        &.down {
            color: var(--v-lightRedDown-base);
        }
    }
}
</style>